module.exports = __webpack_public_path__ + "img/tasks.bb192880.svg";